import styled from 'styled-components';
var Button = styled.button.withConfig({
  displayName: "EnergyLabelBadgestyles__Button",
  componentId: "xm0k6u-0"
})(["border:none;background:transparent;padding:0;"]);
var Wrapper = styled.div.withConfig({
  displayName: "EnergyLabelBadgestyles__Wrapper",
  componentId: "xm0k6u-1"
})(["display:flex;align-items:center;a{margin-left:5px;}"]);
export { Button, Wrapper };